import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../queries/withCount';

const ERRORS = `errors { path, message }`;

const SALESPERSON_FIELDS = `
  id,
  vendor { id, name}
  user { id, firstName, lastName }
  commission { id, name }
  seller { id, name }
`

const SALESPERSON_VARIABLES = `
  $vendorId: ID
  $userId: ID
  $commissionId: ID!
  $sellerId: ID!
`;

const SALESPERSON_ARGUMENTS = `
  vendorId: $vendorId
  userId: $userId
  commissionId: $commissionId
  sellerId: $sellerId
`;

const SALESPERSON_FIELDS_AND_ERRORS = `
  salesperson {
    ${SALESPERSON_FIELDS}
  }
  ${ERRORS}
`;

export const SALESPEOPLE_WITH_COUNT = gql`
  query (
    ${WITH_COUNT_VARIABLES}
  ) {
    salespeopleWithCount(
      ${WITH_COUNT_ARGUMENTS}
    ) {
      entries {
        ${SALESPERSON_FIELDS}
      }
      count
    }
  }
`;

export const CREATE_SALESPERSON = gql`
  mutation CreateSalesperson(
    ${SALESPERSON_VARIABLES}
  ) {
    createSalesperson(
      ${SALESPERSON_ARGUMENTS}
    ) {
      ${SALESPERSON_FIELDS_AND_ERRORS}
    }
  }
`;

export const UPDATE_SALESPERSON = gql`
  mutation UpdateSalesperson(
    $id: ID!
    ${SALESPERSON_VARIABLES}
  ) {
    updateSalesperson(
      id: $id
      ${SALESPERSON_ARGUMENTS}
    ) {
      ${SALESPERSON_FIELDS_AND_ERRORS}
    }
  }
`;

export const SALESPERSON = gql`
  query Salesperson($id: ID!) {
    salesperson(id: $id) {
      ${SALESPERSON_FIELDS}
    }
  }
`;

export const HIDE_SALESPERSON = gql`
  mutation HideSalesperson($id: ID!) {
    hideSalesperson(id: $id) {
      salesperson {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

export const SELECT_OPTIONS = gql`
  query selectOptions {
    commissions {id, name}
    sellers {id, name}
    users {id, firstName, lastName}
    vendors {id, name}
  }
`;
